module.exports = __webpack_public_path__ + "static/img/preview-01.4900e7e1.webp";